/**
 * Support contact details for membership checkout (WhatsApp support button).
 * Set via REACT_APP_CONTACT_* in .env.local — same vars as the container Contact page.
 */
const trimEnv = (key: string): string => process.env[key]?.trim() || "";

export const SUPPORT_CONTACT_PHONE = trimEnv("REACT_APP_CONTACT_PHONE");

export const SUPPORT_CONTACT_PHONE_HREF =
  trimEnv("REACT_APP_CONTACT_PHONE_HREF") ||
  (SUPPORT_CONTACT_PHONE ? SUPPORT_CONTACT_PHONE.replace(/\s/g, "") : "");

const SUPPORT_PHONE_DIGITS = SUPPORT_CONTACT_PHONE_HREF.replace(/\D/g, "");

/** Base WhatsApp URL (without pre-filled message). Empty when not configured. */
export const SUPPORT_WHATSAPP_BASE_URL = (() => {
  const raw = process.env.REACT_APP_CONTACT_WHATSAPP_URL;
  if (raw !== undefined) {
    return raw.trim();
  }
  return SUPPORT_PHONE_DIGITS ? `https://wa.me/${SUPPORT_PHONE_DIGITS}` : "";
})();

/** Builds a WhatsApp deep link with a pre-filled support message. */
export function buildWhatsAppSupportUrl(message: string): string {
  const base = SUPPORT_WHATSAPP_BASE_URL;
  if (!base) return "";
  const separator = base.includes("?") ? "&" : "?";
  return `${base}${separator}text=${encodeURIComponent(message)}`;
}

/** Pre-filled WhatsApp message for subscription pending payment. */
export function subscriptionPendingPaymentWhatsAppMessage(
  subscriptionId: string
): string {
  return `Hello, my subscription was created but payment was not completed. Please help me review it. Membership ID: ${subscriptionId}`;
}
